"use client";

const { library } = require("@fortawesome/fontawesome-svg-core");
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faArrowLeft,
  faArrowRight,
  faArrowDown,
  faArrowRightToBracket,
  faArrowUpRightFromSquare as faArrowUpRight,
  faAt,
  faBan,
  faBolt,
  faBreadSlice,
  faBuilding,
  faCalendarCheck,
  faCertificate,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faClock,
  faCookieBite,
  faCopy,
  faCopyright,
  faEnvelope,
  faEye,
  faFileContract,
  faGraduationCap,
  faHeadset,
  faHeartPulse,
  faHotel,
  faHouse as faHome,
  faIndustry,
  faKitchenSet,
  faLocationDot,
  faMagnifyingGlass,
  faMapLocationDot,
  faPhone,
  faPlus,
  faPlugCircleCheck,
  faRotate,
  faRulerCombined,
  faSchool,
  faSearch,
  faShieldHalved as faShieldCheck,
  faShip,
  faStore,
  faUtensils,
  faWrench,
  faBars,
  faXmark,
  faCubes,
  faChartLine,
  faWifi,
} from "@fortawesome/free-solid-svg-icons";

import {
  faFacebook,
  faLinkedinIn,
  faYelp,
  faGoogle,
  faProductHunt,
  faTelegram,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faPhone,
  faSearch,
  faMagnifyingGlass,
  faArrowUpRight,
  faCopyright,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faHome,
  faAt,
  faEnvelope,
  faLocationDot,
  faArrowRight,
  faEye,
  faXmark,
  faCertificate,
  faRulerCombined,
  faPlugCircleCheck,
  faCalendarCheck,
  faBolt,
  faShieldCheck,
  faGraduationCap,
  faWrench,
  faUtensils,
  faBreadSlice,
  faSchool,
  faBuilding,
  faStore,
  faIndustry,
  faHeadset,
  faClock,
  faRotate,
  faKitchenSet,
  faHotel,
  faHeartPulse,
  faFacebook,
  faLinkedinIn,
  faYelp,
  faGoogle,
  faProductHunt,
  faTelegram,
  faXTwitter,
  faYoutube,
  faLocationDot,
  faShip,
  faFileContract,
  faMapLocationDot,
  faCookieBite,
  faBan,
  faCheck,
  faPlus,
  faArrowLeft,
  faArrowRightToBracket,
  faBars,
  faChevronDown,
  faArrowDown,
  faCubes,
  faChartLine,
  faWifi,
);

const FAIcon = ({
  button,
  buttonPrimary,
  className,
  disabled,
  fixedWidth,
  fixedHeight,
  icon,
  noMargin,
  size,
  spin,
  type,
  color,
}) => {
  const width = fixedHeight ? "auto" : (size ?? 20),
    height = fixedWidth ? "auto" : (size ?? 20);

  const iconType = (type) => {
    return (
      (type === "brand" && "fab") ||
      (type === "solid" && "fas") ||
      (type === "thin" && "fat") ||
      "fas"
    );
  };

  if (!icon) {
    console.error("FAIcon: icon prop is null/undefined:", {
      icon,
      type,
      size,
      color,
    });
    return null;
  }

  const prefix = iconType(type);

  return (
    <FontAwesomeIcon
      icon={[prefix, icon]}
      spin={spin}
      className={`${
        disabled ? "text-gray-400!" : buttonPrimary ? `text-white!` : ``
      } ${className ? className : ``} ${
        button || buttonPrimary ? `cursor-pointer` : ``
      } ${noMargin ? `m-0` : `mr-2`}`}
      style={{
        width: width,
        height: height,
        color: color ? color : undefined,
      }}
    />
  );
};

export default FAIcon;
